import * as XLSX from "xlsx";

export const downloadTaskListTemplate = () => {
  const exampleData = [
    {
      taskName: "Task Name #1",
      jobTitle: "Global Production; Marketing; Assistant",
      taskType: "Production",
      taskOrder: 1,
    },
    {
      taskName: "Task Name #2",
      jobTitle: "Global Production; Marketing; Assistant",
      taskType: "Production",
      taskOrder: 2,
    },
    {
      taskName: "Task Name #3",
      jobTitle: "Marketing; Assistant",
      taskType: "Production",
      taskOrder: 3,
    },
    {
      taskName: "Task Name #4",
      jobTitle: "Assistant",
      taskType: "Non Production",
      taskOrder: 4,
    },
    {
      taskName: "Task Name #5",
      jobTitle: "Assistant",
      taskType: "Non Production",
      taskOrder: 5,
    },
  ];

  const Heading = [["Task Name", "Job Title", "Task Type", "Task Order"]];

  const wb = XLSX.utils.book_new();
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
  XLSX.utils.sheet_add_aoa(ws, Heading);
  XLSX.utils.sheet_add_json(ws, exampleData, {
    origin: "A2",
    skipHeader: true,
  });

  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  XLSX.writeFile(wb, "import-tasks-template.xlsx");
};
